import { _js } from '@ifixit/localize';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Text, useDisclosure } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlass';
import { space } from '@ifixit/primitives';
import DevicePreview from './device_preview';
import * as PopupActions from 'Shared/PopupModal/actions';
import QuestionAsk from '../question_ask';
import { DevicePickerModal } from '@ifixit/device-picker';
import { getSearchClient } from 'Guide/searchClient';
import API_2_0 from 'Shared/api_2_0';

const mapDispatchToProps = dispatch => ({
   pushPopup: popup => dispatch(PopupActions.pushPopup(popup)),
   popPopup: () => dispatch(PopupActions.popPopup()),
});

const ChooseAskDeviceRoot = props => {
   const { isOpen, onClose, onOpen } = useDisclosure();
   const [selectedDevice, setSelectedDevice] = useState({
      dbTitle: props.initialDevice || '',
      displayTitle: props.initialDevice || '',
   });
   const [description, setDescription] = useState('');
   const [imageUrl, setImageUrl] = useState('');
   const [isOrphan, setIsOrphan] = useState(false);
   const deviceSynonym = props.deviceSynonym || _js('Device');
   const deviceSelected = selectedDevice.dbTitle && selectedDevice.dbTitle !== 'No Device';

   useEffect(() => {
      const { initialDevice } = props;
      if (initialDevice) {
         getDeviceData(initialDevice);
      }
   }, []);

   useEffect(() => {
      const deviceInput = document.querySelector('#qaDevice');
      if (deviceInput) {
         deviceInput.value = selectedDevice.display_title || selectedDevice.dbTitle;
         QuestionAsk.markFinished(
            document.querySelector('.js-qa-device-label'),
            selectedDevice.dbTitle !== '' && selectedDevice.dbTitle !== 'No Device'
         );
      }
   }, [selectedDevice]);

   const getDeviceData = device => {
      if (device === '') {
         return;
      }

      const onResolve = data => {
         setDescription(data.description);
         setImageUrl(data.image.thumbnail);
         setIsOrphan(false);
         setSelectedDevice({ dbTitle: data.title, displayTitle: data.display_title });
      };

      const onReject = () => {
         setDescription('');
         setImageUrl('');
         setIsOrphan(true);
         setSelectedDevice({ dbTitle: device, displayTitle: device });
      };

      const encodedTitle = encodeURIComponent(device);

      new API_2_0(`wikis/CATEGORY/${encodedTitle}?langid=${App.lang}`, {
         method: 'GET',
      })
         .send()
         .then(onResolve, onReject);
   };

   return (
      <>
         <DevicePickerModal
            onSelect={device => {
               onClose();
               setSelectedDevice({
                  dbTitle: device.device,
                  displayTitle: device.title,
               });
               setDescription(device.description || '');
               setImageUrl(device.image_url || '');
               setIsOrphan(!device.objectID);
            }}
            algoliaConfig={{
               searchClient: getSearchClient(),
               indexPrefix: App.algoliaConfig['indexPrefix'],
            }}
            oniFixit={App.which === 'ifixit'}
            langid={App.lang}
            storeLocale={App.userPreferredStoreLocale}
            selectionProps={'allowSelectingNewDevices'}
            showUncategorizedDevices={true}
            isOpen={isOpen}
            onOpen={onOpen}
            onClose={onClose}
            analyticsKey={'Answers'}
         />
         {deviceSelected ? (
            <DevicePreview
               title={selectedDevice.displayTitle || selectedDevice.dbTitle}
               description={description}
               imageUrl={imageUrl}
               isOrphan={isOrphan}
               onChangeClick={onOpen}
               editUrl={`/Device/Edit/${encodeURIComponent(selectedDevice.dbTitle)}`}
            />
         ) : (
            <Button
               id="chooseAskDeviceButton"
               width="full"
               onClick={event => {
                  onOpen();
                  event.preventDefault();
               }}
            >
               <FontAwesomeIcon icon={faMagnifyingGlass} />
               <Text marginLeft={space[2]}>
                  {
                     /* Translators: %1 -> site specific device synonym */
                     _js('Find %1', deviceSynonym)
                  }
               </Text>
            </Button>
         )}
      </>
   );
};

export default connect(null, mapDispatchToProps)(ChooseAskDeviceRoot);
